<nav class="navigation-tabs nav_desktop" role="navigation">
    <ul>
        <li>
            <a href="https://www.theaa.com/route-planner/route" class="hide_nav_link">Route planner</a>
            <a [routerLink]="routeLink" (click) = "getClick(routeLink)" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: false }">Route planner</a>
        </li>
        <li>
            <a href="https://www.theaa.com/route-planner/traffic-news" class="hide_nav_link">Traffic news</a>
            <a [routerLink]="trafficLink"  (click) = "getClick(trafficLink)" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: false }">Traffic news</a>
        </li>
        <li>
            <a href="https://www.theaa.com/route-planner/maps-hotels" class="hide_nav_link">Maps & AA hotels</a>
            <a [routerLink]="mapLink"  (click) = "getClick(mapLink)"  routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: false }">Maps & AA Hotels</a>
        </li>
    </ul>
</nav>
